import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Utilities_ReportService } from './Utilities.report.index';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Utilities.frontend.types'
import { $frontendTypes as $types} from './Utilities.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { Utilities_statuses_dd_singleComponent } from './Utilities.statuses_dd_single.component'
import { Utilities_directions_dd_singleComponent } from './Utilities.directions_dd_single.component'
import { Utilities_transaction_types_dd_singleComponent } from './Utilities.transaction_types_dd_single.component'
import { Utilities_processes_dd_singleComponent } from './Utilities.processes_dd_single.component'


interface IUtilities_messages_gridComponentEntity {
message_id?: string, application_name?: string, process_name?: string, transaction_type?: string, transaction_id?: string, status_name?: string, environment?: string, direction?: string, reference?: string, payload?: string, notes?: string, message?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string, date_number?: number}

interface IUtilities_messages_gridComponentInParams {
  application_name?: string, transaction_id?: string, grid_title?: string, column_names?: { number_1?: string, number_2?: string, number_3?: string, number_4?: string, number_5?: string, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string }, filter_values?: { number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string }}


class Utilities_messages_gridComponentRowModel extends GridRowModel {
  grid: Utilities_messages_gridComponent;
  entity: IUtilities_messages_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    json_test_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    xml_test_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  override cells = {
    id: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    application_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    process_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    transaction_type: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    transaction_id: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    status_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    environment: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    direction: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    payload: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    notes: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    message: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    created_by: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    created_on: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    modified_by: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    modified_on: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    number_1: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    number_2: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    number_3: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    number_4: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    number_5: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    string_1: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    string_2: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    string_3: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    string_4: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    string_5: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    json_test: new GridCellModel(
      new CellStyles(null, null),
       new CodeBoxModel(this.formGroup.controls['json_test_display'] as DatexFormControl, null, null,'json', null)
,
null
      ),
    xml_test: new GridCellModel(
      new CellStyles(null, null),
       new CodeBoxModel(this.formGroup.controls['xml_test_display'] as DatexFormControl, null, null,'xml', null)
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: Utilities_ShellService,
private datasources: Utilities_DatasourceService,
private flows: Utilities_FlowService,
private reports: Utilities_ReportService,
private localization: Utilities_LocalizationService,
private operations: Utilities_OperationService,
private logger: CleanupLoggerService,
) {
    super();
    
  }

  async $initializeExisting(grid: Utilities_messages_gridComponent, entity: IUtilities_messages_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.message_id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: Utilities_messages_gridComponent, entity?: IUtilities_messages_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.message_id].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = this.entity.message_id;
    const inParams = {
      $keys:[$resultKey],
      application_name:  $grid.inParams.application_name ,
      date_from:  $grid.filters.date_from.control.value ,
      date_to:  $grid.filters.date_to.control.value ,
      full_text_search:  $grid.fullTextSearch ,
      process_name:  $grid.filters.process.control.value ,
      transaction_id:  $grid.inParams.transaction_id ,
      status_name:  $grid.filters.status.control.value ,
      reference:  null ,
      transaction_type:  $grid.filters.transaction_type.control.value ,
      direction:  $grid.filters.direction.control.value ,
      environment:  null ,
      string_1:  $grid.inParams.filter_values?.string_1 ,
      string_2:  $grid.inParams.filter_values?.string_2 ,
      string_3:  $grid.inParams.filter_values?.string_3 ,
      string_4:  $grid.inParams.filter_values?.string_4 ,
      string_5:  $grid.inParams.filter_values?.string_5 ,
      number_1:  $grid.inParams.filter_values?.number_1 ,
      number_2:  $grid.inParams.filter_values?.number_2 ,
      number_3:  $grid.inParams.filter_values?.number_3 ,
      number_4:  $grid.inParams.filter_values?.number_4 ,
      number_5:  $grid.inParams.filter_values?.number_5 ,
    };
    const data = await this.datasources.Utilities.ds_messages_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.id.displayControl as TextModel).text = $row.entity.message_id;
    (this.cells.application_name.displayControl as TextModel).text = $row.entity.application_name;
    (this.cells.process_name.displayControl as TextModel).text = $row.entity.process_name;
    (this.cells.transaction_type.displayControl as TextModel).text = $row.entity.transaction_type;
    (this.cells.transaction_id.displayControl as TextModel).text = $row.entity.transaction_id;
    (this.cells.status_name.displayControl as TextModel).text = $row.entity.status_name;
    (this.cells.environment.displayControl as TextModel).text = $row.entity.environment;
    (this.cells.direction.displayControl as TextModel).text = $row.entity.direction;
    (this.cells.reference.displayControl as TextModel).text = $row.entity.reference;
    (this.cells.payload.displayControl as TextModel).text = $row.entity.payload;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.notes;
    (this.cells.message.displayControl as TextModel).text = $row.entity.message;
    (this.cells.created_by.displayControl as TextModel).text = $row.entity.created_by;
    (this.cells.created_on.displayControl as TextModel).text = $row.entity.created_on?.toString();
    (this.cells.modified_by.displayControl as TextModel).text = $row.entity.modified_by;
    (this.cells.modified_on.displayControl as TextModel).text = $row.entity.modified_on?.toString();
    (this.cells.number_1.displayControl as TextModel).text = $row.entity.number_1?.toString();
    (this.cells.number_2.displayControl as TextModel).text = $row.entity.number_2?.toString();
    (this.cells.number_3.displayControl as TextModel).text = $row.entity.number_3?.toString();
    (this.cells.number_4.displayControl as TextModel).text = $row.entity.number_4?.toString();
    (this.cells.number_5.displayControl as TextModel).text = $row.entity.number_5?.toString();
    (this.cells.string_1.displayControl as TextModel).text = $row.entity.string_1;
    (this.cells.string_2.displayControl as TextModel).text = $row.entity.string_2;
    (this.cells.string_3.displayControl as TextModel).text = $row.entity.string_3;
    (this.cells.string_4.displayControl as TextModel).text = $row.entity.string_4;
    (this.cells.string_5.displayControl as TextModel).text = $row.entity.string_5;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'transaction_id' : {
        this.on_transaction_clicked();
        break;
      }
      case 'payload' : {
        this.on_payload_clicked();
        break;
      }
      case 'notes' : {
        this.on_notes_clicked();
        break;
      }
      case 'message' : {
        this.on_message_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_message_clicked(event = null) {
    return this.on_message_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_message_clickedInternal(
    $row: Utilities_messages_gridComponentRowModel,
  $grid: Utilities_messages_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_message_clicked');
  //O.Arias - 06/20/2024
  
  let is_json: boolean = false;
  let is_xml: boolean = false;
  
  let payload_string: string = $row.entity.message;
  
  if ($utils.isDefined(payload_string)) {
      payload_string = payload_string.trim();
  
      try {
          $row.cells.json_test.displayControl.value = payload_string;
          if ($utils.isDefined($row.cells.json_test.displayControl.value)) {
              is_json = true;
          }
      } catch (e) { }
  
      try {
          if (payload_string.includes("<") && payload_string.includes(">")) {
              $row.cells.xml_test.displayControl.value = payload_string;
              if ($utils.isDefined($row.cells.xml_test.displayControl.value)) {
                  is_xml = true;
              }
          }
      } catch (e) { }
  
      if (is_json) {
          await $shell.Utilities.openview_json_payloadDialog({
              payload: payload_string,
              title: "Notes"
          }, "modal", EModalSize.Xlarge);
      } else if (is_xml) {
          await $shell.Utilities.openview_xml_payloadDialog({
              payload: payload_string,
              title: "Notes"
          }, "modal", EModalSize.Xlarge);
      } else {
          $shell.Utilities.openInfoDialog("Notes", payload_string);
      }
  }
  }
  on_notes_clicked(event = null) {
    return this.on_notes_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_notes_clickedInternal(
    $row: Utilities_messages_gridComponentRowModel,
  $grid: Utilities_messages_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_notes_clicked');
  //O.Arias - 06/20/2024
  
  let is_json: boolean = false;
  let is_xml: boolean = false;
  
  let payload_string: string = $row.entity.notes;
  
  if ($utils.isDefined(payload_string)) {
      payload_string = payload_string.trim();
  
      try {
          $row.cells.json_test.displayControl.value = payload_string;
          if ($utils.isDefined($row.cells.json_test.displayControl.value)) {
              is_json = true;
          }
      } catch (e) { }
  
      try {
          if (payload_string.includes("<") && payload_string.includes(">")) {
              $row.cells.xml_test.displayControl.value = payload_string;
              if ($utils.isDefined($row.cells.xml_test.displayControl.value)) {
                  is_xml = true;
              }
          }
      } catch (e) { }
  
      if (is_json) {
          await $shell.Utilities.openview_json_payloadDialog({
              payload: payload_string,
              title: "Notes"
          }, "modal", EModalSize.Xlarge);
      } else if (is_xml) {
          await $shell.Utilities.openview_xml_payloadDialog({
              payload: payload_string,
              title: "Notes"
          }, "modal", EModalSize.Xlarge);
      } else {
          $shell.Utilities.openInfoDialog("Notes", payload_string);
      }
  }
  }
  on_payload_clicked(event = null) {
    return this.on_payload_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_payload_clickedInternal(
    $row: Utilities_messages_gridComponentRowModel,
  $grid: Utilities_messages_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_payload_clicked');
  //O.Arias - 06/20/2024
  
  let is_json: boolean = false;
  let is_xml: boolean = false;
  
  let payload_string: string = $row.entity.payload;
  
  if ($utils.isDefined(payload_string)) {
      payload_string = payload_string.trim();
  
      try {
          $row.cells.json_test.displayControl.value = payload_string;
          if ($utils.isDefined($row.cells.json_test.displayControl.value)) {
              is_json = true;
          }
      } catch (e) { }
  
      try {
          if (payload_string.includes("<") && payload_string.includes(">")) {
              $row.cells.xml_test.displayControl.value = payload_string;
              if ($utils.isDefined($row.cells.xml_test.displayControl.value)) {
                  is_xml = true;
              }
          }
      } catch (e) { }
  
      if (is_json) {
          await $shell.Utilities.openview_json_payloadDialog({
              payload: payload_string,
              title: "Notes"
          }, "modal", EModalSize.Xlarge);
      } else if (is_xml) {
          await $shell.Utilities.openview_xml_payloadDialog({
              payload: payload_string,
              title: "Notes"
          }, "modal", EModalSize.Xlarge);
      } else {
          $shell.Utilities.openInfoDialog("Notes", payload_string);
      }
  }
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: Utilities_messages_gridComponentRowModel,
  $grid: Utilities_messages_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_row_data_loaded');
  //O.Arias - 06/20/2024
  
  const format = `MM/DD/YYYY, LT`;
  
  if ($utils.isDefined(format)) {
      if ($utils.isDefined($row.entity.created_on)) {
          $row.cells.created_on.displayControl.text = $utils.date.format($row.entity.created_on, format);
      }
      if ($utils.isDefined($row.entity.modified_on)) {
          $row.cells.modified_on.displayControl.text = $utils.date.format($row.entity.modified_on, format);
      }
  }
  
  let payload = $row.entity.payload;
  
  if ($utils.isDefined(payload)) {
      payload = (payload.length > 75) ? payload.substring(0, 75) : payload;
      $row.cells.payload.displayControl.text = payload;
  }
  
  let notes = $row.entity.notes;
  
  if ($utils.isDefined(notes)) {
      notes = (notes.length > 75) ? notes.substring(0, 75) : notes;
      $row.cells.notes.displayControl.text = notes;
  }
  
  let message = $row.entity.message;
  
  if ($utils.isDefined(message)) {
      message = (message.length > 75) ? message.substring(0, 75) : message;
      $row.cells.message.displayControl.text = message;
  }
  }
  on_transaction_clicked(event = null) {
    return this.on_transaction_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_transaction_clickedInternal(
    $row: Utilities_messages_gridComponentRowModel,
  $grid: Utilities_messages_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_transaction_clicked');
  //O.Arias - 06/20/2024
  
  if (!$utils.isDefined($grid.inParams.transaction_id)) {
  
      let transaction_id: string = $row.entity.transaction_id;
  
      if ($utils.isDefined(transaction_id)) {
          if (transaction_id !== "") {
              $shell.Utilities.opentransaction_hubDialog({ column_names: $grid.inParams.column_names, transaction_id: transaction_id }, "modal", EModalSize.Xlarge);
          }
      }
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Utilities_statuses_dd_singleComponent),
    forwardRef(() => Utilities_directions_dd_singleComponent),
    forwardRef(() => Utilities_transaction_types_dd_singleComponent),
    forwardRef(() => Utilities_processes_dd_singleComponent),
  ],
  selector: 'Utilities-messages_grid',
  templateUrl: './Utilities.messages_grid.component.html'
})
export class Utilities_messages_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IUtilities_messages_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IUtilities_messages_gridComponentInParams = { application_name: null, transaction_id: null, grid_title: null, column_names: { number_1: null, number_2: null, number_3: null, number_4: null, number_5: null, string_1: null, string_2: null, string_3: null, string_4: null, string_5: null }, filter_values: { number_1: null, number_2: null, number_3: null, number_4: null, number_5: null, string_1: null, string_2: null, string_3: null, string_4: null, string_5: null } };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     id: new GridHeaderModel(new HeaderStyles(null, null), 'ID', false, false, null),       application_name: new GridHeaderModel(new HeaderStyles(null, null), 'Application', false, false, null),       process_name: new GridHeaderModel(new HeaderStyles(null, null), 'Process', false, false, null),       transaction_type: new GridHeaderModel(new HeaderStyles(null, null), 'Type', false, false, null),       transaction_id: new GridHeaderModel(new HeaderStyles(null, null), 'Transaction', false, false, null),       status_name: new GridHeaderModel(new HeaderStyles(null, null), 'Status', false, false, null),       environment: new GridHeaderModel(new HeaderStyles(null, null), 'Environment', false, false, null),       direction: new GridHeaderModel(new HeaderStyles(null, null), 'Direction', false, false, null),       reference: new GridHeaderModel(new HeaderStyles(null, null), 'Reference', false, false, null),       payload: new GridHeaderModel(new HeaderStyles(null, null), 'Payload', false, false, null),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', false, false, null),       message: new GridHeaderModel(new HeaderStyles(null, null), 'Message', false, false, null),       created_by: new GridHeaderModel(new HeaderStyles(null, null), 'Created by', false, false, null),       created_on: new GridHeaderModel(new HeaderStyles(null, null), 'Created on', false, false, null),       modified_by: new GridHeaderModel(new HeaderStyles(null, null), 'Modified by', false, false, null),       modified_on: new GridHeaderModel(new HeaderStyles(null, null), 'Modified on', false, false, null),       number_1: new GridHeaderModel(new HeaderStyles(null, null), 'Number 1', false, false, null),       number_2: new GridHeaderModel(new HeaderStyles(null, null), 'Number 2', false, false, null),       number_3: new GridHeaderModel(new HeaderStyles(null, null), 'Number 3', false, false, null),       number_4: new GridHeaderModel(new HeaderStyles(null, null), 'Number 4', false, false, null),       number_5: new GridHeaderModel(new HeaderStyles(null, null), 'Number 5', false, false, null),       string_1: new GridHeaderModel(new HeaderStyles(null, null), 'String 1', false, false, null),       string_2: new GridHeaderModel(new HeaderStyles(null, null), 'String 2', false, false, null),       string_3: new GridHeaderModel(new HeaderStyles(null, null), 'String 3', false, false, null),       string_4: new GridHeaderModel(new HeaderStyles(null, null), 'String 4', false, false, null),       string_5: new GridHeaderModel(new HeaderStyles(null, null), 'String 5', false, false, null),       json_test: new GridHeaderModel(new HeaderStyles(null, null), 'Json test', false, false, null),       xml_test: new GridHeaderModel(new HeaderStyles(null, null), 'Xml test', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Utilities_messages_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('application_name') set $inParams_application_name(value: any) {
    this.inParams['application_name'] = value;
  }
  get $inParams_application_name(): any {
    return this.inParams['application_name'] ;
  }
  @Input('transaction_id') set $inParams_transaction_id(value: any) {
    this.inParams['transaction_id'] = value;
  }
  get $inParams_transaction_id(): any {
    return this.inParams['transaction_id'] ;
  }
  @Input('grid_title') set $inParams_grid_title(value: any) {
    this.inParams['grid_title'] = value;
  }
  get $inParams_grid_title(): any {
    return this.inParams['grid_title'] ;
  }
  @Input('column_names') set $inParams_column_names(value: any) {
    this.inParams['column_names'] = value;
  }
  get $inParams_column_names(): any {
    return this.inParams['column_names'] ;
  }
  @Input('filter_values') set $inParams_filter_values(value: any) {
    this.inParams['filter_values'] = value;
  }
  get $inParams_filter_values(): any {
    return this.inParams['filter_values'] ;
  }

  topToolbar = {
      delete_message: new ToolModel(new ButtonModel('delete_message', new ButtonStyles(['destructive'], null), false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      resubmit_message: new ToolModel(new ButtonModel('resubmit_message', new ButtonStyles(['creation'], null), false, false, 'Resubmit', 'icon-ic_fluent_replay_20_regular', null)
    , false),
      clean_message: new ToolModel(new ButtonModel('clean_message', new ButtonStyles(['creation'], null), false, false, 'Clean', 'icon-ic_fluent_recycle_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    direction: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    transaction_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    process: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false, 
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
    direction: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['direction'] as DatexFormControl, 
  null, null,
  false, 
  '', null)
, new ControlContainerStyles(null, null), 'Direction', false, false),
    transaction_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['transaction_type'] as DatexFormControl, 
  null, null,
  false, 
  '', null)
, new ControlContainerStyles(null, null), 'Type', false, false),
    process: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['process'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false, 
  '', null)
, new ControlContainerStyles(null, null), 'Process', false, false),
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
  }

  //#region filters inParams
  get $fields_status_selector_inParams_application_name(): string {
    const $grid = this;
    const $utils = this.utils;
    const expr = $grid.inParams.application_name;
    
    return expr;
  }

  get $fields_transaction_type_selector_inParams_application_name(): string {
    const $grid = this;
    const $utils = this.utils;
    const expr = $grid.inParams.application_name;
    
    return expr;
  }

  get $fields_process_selector_inParams_application_name(): string {
    const $grid = this;
    const $utils = this.utils;
    const expr = $grid.inParams.application_name;
    
    return expr;
  }

  //#endregion filters inParams

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: Utilities_ShellService,
    private datasources: Utilities_DatasourceService,
    private flows: Utilities_FlowService,
    private reports: Utilities_ReportService,
    private localization: Utilities_LocalizationService,
    private operations: Utilities_OperationService,
    private logger: CleanupLoggerService,
    ) {
    super();
    this.title = 'Messages';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      application_name:  $grid.inParams.application_name ,
      date_from:  $grid.filters.date_from.control.value ,
      date_to:  $grid.filters.date_to.control.value ,
      full_text_search:  $grid.fullTextSearch ,
      process_name:  $grid.filters.process.control.value ,
      transaction_id:  $grid.inParams.transaction_id ,
      status_name:  $grid.filters.status.control.value ,
      reference:  null ,
      transaction_type:  $grid.filters.transaction_type.control.value ,
      direction:  $grid.filters.direction.control.value ,
      environment:  null ,
      string_1:  $grid.inParams.filter_values?.string_1 ,
      string_2:  $grid.inParams.filter_values?.string_2 ,
      string_3:  $grid.inParams.filter_values?.string_3 ,
      string_4:  $grid.inParams.filter_values?.string_4 ,
      string_5:  $grid.inParams.filter_values?.string_5 ,
      number_1:  $grid.inParams.filter_values?.number_1 ,
      number_2:  $grid.inParams.filter_values?.number_2 ,
      number_3:  $grid.inParams.filter_values?.number_3 ,
      number_4:  $grid.inParams.filter_values?.number_4 ,
      number_5:  $grid.inParams.filter_values?.number_5 ,
    };
    try {
    const data = await this.datasources.Utilities.ds_messages_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Utilities_messages_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations,
          this.logger);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_data_loaded');
  //O.Arias - 06/24/2024
  
  if ($utils.isDefined($grid.rows)) {
  
      let process_name = $grid.rows.filter(r => $utils.isDefined(r.entity.process_name))?.map(r => r.entity.process_name); if ($utils.isDefined(process_name)) { $grid.headers.process_name.hidden = false } else { $grid.headers.process_name.hidden = true }
      let transaction_type = $grid.rows.filter(r => $utils.isDefined(r.entity.transaction_type))?.map(r => r.entity.transaction_type); if ($utils.isDefined(transaction_type)) { $grid.headers.transaction_type.hidden = false } else { $grid.headers.transaction_type.hidden = true }
      let transaction_id = $grid.rows.filter(r => $utils.isDefined(r.entity.transaction_id))?.map(r => r.entity.transaction_id); if ($utils.isDefined(transaction_id)) { $grid.headers.transaction_id.hidden = false } else { $grid.headers.transaction_id.hidden = true }
      let status_name = $grid.rows.filter(r => $utils.isDefined(r.entity.status_name))?.map(r => r.entity.status_name); if ($utils.isDefined(status_name)) { $grid.headers.status_name.hidden = false } else { $grid.headers.status_name.hidden = true }
      let environment = $grid.rows.filter(r => $utils.isDefined(r.entity.environment))?.map(r => r.entity.environment); if ($utils.isDefined(environment)) { $grid.headers.environment.hidden = false } else { $grid.headers.environment.hidden = true }
      let direction = $grid.rows.filter(r => $utils.isDefined(r.entity.direction))?.map(r => r.entity.direction); if ($utils.isDefined(direction)) { $grid.headers.direction.hidden = false } else { $grid.headers.direction.hidden = true }
      let reference = $grid.rows.filter(r => $utils.isDefined(r.entity.reference))?.map(r => r.entity.reference); if ($utils.isDefined(reference)) { $grid.headers.reference.hidden = false } else { $grid.headers.reference.hidden = true }
      let payload = $grid.rows.filter(r => $utils.isDefined(r.entity.payload))?.map(r => r.entity.payload); if ($utils.isDefined(payload)) { $grid.headers.payload.hidden = false } else { $grid.headers.payload.hidden = true }
      let notes = $grid.rows.filter(r => $utils.isDefined(r.entity.notes))?.map(r => r.entity.notes); if ($utils.isDefined(notes)) { $grid.headers.notes.hidden = false } else { $grid.headers.notes.hidden = true }
      let message = $grid.rows.filter(r => $utils.isDefined(r.entity.message))?.map(r => r.entity.message); if ($utils.isDefined(message)) { $grid.headers.message.hidden = false } else { $grid.headers.message.hidden = true }
      let created_by = $grid.rows.filter(r => $utils.isDefined(r.entity.created_by))?.map(r => r.entity.created_by); if ($utils.isDefined(created_by)) { $grid.headers.created_by.hidden = false } else { $grid.headers.created_by.hidden = true }
      let created_on = $grid.rows.filter(r => $utils.isDefined(r.entity.created_on))?.map(r => r.entity.created_on); if ($utils.isDefined(created_on)) { $grid.headers.created_on.hidden = false } else { $grid.headers.created_on.hidden = true }
      let modified_by = $grid.rows.filter(r => $utils.isDefined(r.entity.modified_by))?.map(r => r.entity.modified_by); if ($utils.isDefined(modified_by)) { $grid.headers.modified_by.hidden = false } else { $grid.headers.modified_by.hidden = true }
      let modified_on = $grid.rows.filter(r => $utils.isDefined(r.entity.modified_on))?.map(r => r.entity.modified_on); if ($utils.isDefined(modified_on)) { $grid.headers.modified_on.hidden = false } else { $grid.headers.modified_on.hidden = true }
      let number_1 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_1))?.map(r => r.entity.number_1); if ($utils.isDefined(number_1)) { $grid.headers.number_1.hidden = false } else { $grid.headers.number_1.hidden = true }
      let number_2 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_2))?.map(r => r.entity.number_2); if ($utils.isDefined(number_2)) { $grid.headers.number_2.hidden = false } else { $grid.headers.number_2.hidden = true }
      let number_3 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_3))?.map(r => r.entity.number_3); if ($utils.isDefined(number_3)) { $grid.headers.number_3.hidden = false } else { $grid.headers.number_3.hidden = true }
      let number_4 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_4))?.map(r => r.entity.number_4); if ($utils.isDefined(number_4)) { $grid.headers.number_4.hidden = false } else { $grid.headers.number_4.hidden = true }
      let number_5 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_5))?.map(r => r.entity.number_5); if ($utils.isDefined(number_5)) { $grid.headers.number_5.hidden = false } else { $grid.headers.number_5.hidden = true }
      let string_1 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_1))?.map(r => r.entity.string_1); if ($utils.isDefined(string_1)) { $grid.headers.string_1.hidden = false } else { $grid.headers.string_1.hidden = true }
      let string_2 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_2))?.map(r => r.entity.string_2); if ($utils.isDefined(string_2)) { $grid.headers.string_2.hidden = false } else { $grid.headers.string_2.hidden = true }
      let string_3 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_3))?.map(r => r.entity.string_3); if ($utils.isDefined(string_3)) { $grid.headers.string_3.hidden = false } else { $grid.headers.string_3.hidden = true }
      let string_4 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_4))?.map(r => r.entity.string_4); if ($utils.isDefined(string_4)) { $grid.headers.string_4.hidden = false } else { $grid.headers.string_4.hidden = true }
      let string_5 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_5))?.map(r => r.entity.string_5); if ($utils.isDefined(string_5)) { $grid.headers.string_5.hidden = false } else { $grid.headers.string_5.hidden = true }
  
  }
  
  let application_name: string = $grid.inParams.application_name ?? "";
  
  if (application_name.toUpperCase() === "NULL") {
      application_name = "";
  }
  
  let transaction_id: string = $grid.inParams.transaction_id ?? "";
  
  if (transaction_id.toUpperCase() === "NULL") {
      transaction_id = "";
  }
  
  if (application_name !== "" || transaction_id !== "") {
      $grid.headers.application_name.hidden = true;
  } else {
      $grid.headers.application_name.hidden = false;
  }
  
  if (($grid.totalCount ?? 0) <= 5000) {
      $grid.topToolbar.clean_message.hidden = true;
  } else {
      $grid.topToolbar.clean_message.hidden = false;
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_init');
  //O.Arias - 06/20/2024
  
  $grid.title = 'Messages'
  $grid.headers.id.hidden = true;
  $grid.headers.xml_test.hidden = true;
  $grid.headers.json_test.hidden = true;
  $grid.topToolbar.delete_message.control.readOnly = true;
  $grid.topToolbar.resubmit_message.control.readOnly = true;
  
  let grid_title: string = $grid.inParams.grid_title ?? "";
  let application_name: string = $grid.inParams.application_name ?? "";
  
  if (application_name.toUpperCase() === "NULL") {
      application_name = "";
  }
  
  if (application_name !== "") {
      $grid.headers.application_name.hidden = true;
  }
  
  if (grid_title !== "") {
      $grid.title = grid_title
  }
  
  if ($utils.isDefined($grid.inParams.column_names)) {
  
      let column_names = $grid.inParams.column_names;
  
      if ($utils.isDefined(column_names.number_1)) { $grid.headers.number_1.name = column_names.number_1 }
      if ($utils.isDefined(column_names.number_2)) { $grid.headers.number_2.name = column_names.number_2 }
      if ($utils.isDefined(column_names.number_3)) { $grid.headers.number_3.name = column_names.number_3 }
      if ($utils.isDefined(column_names.number_4)) { $grid.headers.number_4.name = column_names.number_4 }
      if ($utils.isDefined(column_names.number_5)) { $grid.headers.number_5.name = column_names.number_5 }
      if ($utils.isDefined(column_names.string_1)) { $grid.headers.string_1.name = column_names.string_1 }
      if ($utils.isDefined(column_names.string_2)) { $grid.headers.string_2.name = column_names.string_2 }
      if ($utils.isDefined(column_names.string_3)) { $grid.headers.string_3.name = column_names.string_3 }
      if ($utils.isDefined(column_names.string_4)) { $grid.headers.string_4.name = column_names.string_4 }
      if ($utils.isDefined(column_names.string_5)) { $grid.headers.string_5.name = column_names.string_5 }
  }
  
  //{ "number_1": "Numeric one", "number_2": "Numeric two", "number_3": "Numeric three", "number_4": "Numeric four", "number_5": "Numeric five", "string_1": "Transaction id", "string_2": "Egress id", "string_3": "Text three", "string_4": "Text four", "string_5": "Text five" }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_delete_clicked');
  //O.Arias - 06/22/2024
  
  const selected_rows = $grid.selectedRows;
  let errors: { reference: string, id: string, errorMessages: string[] }[] = [];
  let deleted_records: string[] = [];
  
  if (selected_rows.length === 0) {
      $shell.Utilities.openErrorDialog('Delete error!', 'No records were selected!');
      return;
  } else {
  
      const confirm_purge = (await $shell.Utilities.openConfirmationDialog(`Confirm delete!`, `Do you want to delete ${selected_rows.length} records?`, `Delete`, `Cancel`));
  
      if (confirm_purge) {
  
          for (const row of selected_rows) {
  
              let current_error: string;
              let success = false;
              current_error = null;
  
              try {
  
                  let entity = row.entity
  
                  await $flows.Utilities.messages_delete({
                      input: [{ message_id: entity.message_id }],
                      criteria: { application_name: entity.application_name }
                  });
  
                  let log: $types.Utilities.Log;
                  log = entity;
                  log.process_name = `messages_grid`;
                  log.notes = `Deleted record! Reference: [${entity.reference}] Transaction Id: [${entity.transaction_id}] Payload: [${JSON.stringify(entity.payload)}]`;
                  delete log["created_by"]
                  delete log["created_on"]
                  delete log["alerted_on"]
  
                  await $flows.Utilities.logs_write({
                      input: [log],
                      criteria: { application_name: entity.application_name }
                  });
  
                  success = true;
  
              } catch (error) {
  
                  let target_error = error;
  
                  if (typeof target_error === "string") {
                      target_error = { message: target_error };
                  } else {
                      while ($utils.isDefined(target_error.error)) {
                          target_error = target_error.error;
                      };
                  };
  
                  if (!$utils.isDefined(target_error.message)) {
                      target_error = { message: `Uncaught exception! ${JSON.stringify(target_error)}` };
                  };
  
                  current_error = target_error.message;
              };
  
              if (success) {
                  deleted_records.push(row.entity.message_id.toString())
              } else {
                  errors.push({
                      reference: row.entity.reference, id: row.entity.message_id, errorMessages: [current_error]
                  });
              };
          };
  
          if ($utils.isDefined(errors)) {
              await $shell.Utilities.openErrorDialog(
                  `Delete record${selected_rows.length > 1 ? 's' : ''}`,
                  deleted_records.length > 0 ? `Record${selected_rows.length > 1 ? 's' : ''} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: deleted_records })).formattedValue} successfully deleted.` : `No records were deleted.`,
                  null,
                  `Errors deleting record${selected_rows.length > 1 ? 's' : ''}`,
                  errors.map(error => ({ detail: error.errorMessages[0], message: `Id: ${error.id} Reference: ${error.reference}` })))
          };
      };
  };
  
  $grid.refresh();
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_export_flow');
  //O.Arias - 06/22/2024
  
  if ($grid.rows.length > 0) {
  
      let ids: string[] = [];
  
      if ($utils.isDefined($grid.selectedRows)) {
          if ($grid.selectedRows.length > 0) {
              ids = $grid.selectedRows.map(o => o.entity.message_id);
          }
      }
  
      let full_text_search = $grid.fullTextSearch;
      let transaction_id = $grid.inParams.transaction_id;
      let status_name = $grid.filters.status.control.value;
      let direction = $grid.filters.direction.control.value;
      let application_name = $grid.inParams.application_name;
      let transaction_type = $grid.filters.transaction_type.control.value;
  
      let data = (await $datasources.Utilities.ds_messages_grid.getList({
          $skip: 0,
          $top: 1000,
          direction: direction,
          status_name: status_name,
          transaction_id: transaction_id,
          transaction_type: transaction_type,
          full_text_search: full_text_search,
          application_name: application_name,
          date_to: $grid.filters.date_to.control.value,
          date_from: $grid.filters.date_from.control.value,
          number_1: $grid.inParams.filter_values?.number_1,
          number_2: $grid.inParams.filter_values?.number_2,
          number_3: $grid.inParams.filter_values?.number_3,
          number_4: $grid.inParams.filter_values?.number_4,
          number_5: $grid.inParams.filter_values?.number_5,
          string_1: $grid.inParams.filter_values?.string_1,
          string_2: $grid.inParams.filter_values?.string_2,
          string_3: $grid.inParams.filter_values?.string_3,
          string_4: $grid.inParams.filter_values?.string_4,
          string_5: $grid.inParams.filter_values?.string_5
      }));
  
      if (data.totalCount > 0) {
  
          let message: any;
          let messages: any[] = [];
  
          let results = data.result;
  
          if (ids.length > 0) {
              results = results.filter(r => ids.indexOf(r.message_id) >= 0);
          };
  
          for (let result of results) {
              message = {
                  "Application": result.application_name,
                  "Environment": result.environment,
                  "Status": result.status_name,
                  "Direction": result.direction,
                  "Process": result.process_name,
                  "Reference": result.reference,
                  "Payload": result.payload.substring(0, 30000),
                  "Notes": result.notes.substring(0, 30000),
                  "Message": result.message.substring(0, 30000),
                  "Transaction Type": result.transaction_type,
                  "Transaction Id": result.transaction_id,
                  "Created By": result.created_by,
                  "Created On (UTC)": result.created_on,
                  "Modified By": result.modified_by,
                  "Modified On (UTC)": result.modified_on
              }
  
              if ($utils.isDefined(result.number_1)) { let name = "Number 1"; if ($utils.isDefined($grid.inParams.column_names?.number_1)) { name = $grid.inParams.column_names?.number_1 } message[name] = result.number_1 }
              if ($utils.isDefined(result.number_2)) { let name = "Number 2"; if ($utils.isDefined($grid.inParams.column_names?.number_2)) { name = $grid.inParams.column_names?.number_2 } message[name] = result.number_2 }
              if ($utils.isDefined(result.number_3)) { let name = "Number 3"; if ($utils.isDefined($grid.inParams.column_names?.number_3)) { name = $grid.inParams.column_names?.number_3 } message[name] = result.number_3 }
              if ($utils.isDefined(result.number_4)) { let name = "Number 4"; if ($utils.isDefined($grid.inParams.column_names?.number_4)) { name = $grid.inParams.column_names?.number_4 } message[name] = result.number_4 }
              if ($utils.isDefined(result.number_5)) { let name = "Number 5"; if ($utils.isDefined($grid.inParams.column_names?.number_5)) { name = $grid.inParams.column_names?.number_5 } message[name] = result.number_5 }
  
              if ($utils.isDefined(result.string_1)) { let name = "String 1"; if ($utils.isDefined($grid.inParams.column_names?.string_1)) { name = $grid.inParams.column_names?.string_1 } message[name] = result.string_1 }
              if ($utils.isDefined(result.string_2)) { let name = "String 2"; if ($utils.isDefined($grid.inParams.column_names?.string_2)) { name = $grid.inParams.column_names?.string_2 } message[name] = result.string_2 }
              if ($utils.isDefined(result.string_3)) { let name = "String 3"; if ($utils.isDefined($grid.inParams.column_names?.string_3)) { name = $grid.inParams.column_names?.string_3 } message[name] = result.string_3 }
              if ($utils.isDefined(result.string_4)) { let name = "String 4"; if ($utils.isDefined($grid.inParams.column_names?.string_4)) { name = $grid.inParams.column_names?.string_4 } message[name] = result.string_4 }
              if ($utils.isDefined(result.string_5)) { let name = "String 5"; if ($utils.isDefined($grid.inParams.column_names?.string_5)) { name = $grid.inParams.column_names?.string_5 } message[name] = result.string_5 }
  
              messages.push(message)
          }
  
          let wb = $event;
          let ws = $utils.excel.json_to_sheet(messages);
          $utils.excel.book_append_sheet(wb, ws, "Messages");
  
      } else {
          $shell.Utilities.openInfoDialog('Error', 'The parameters did not return any records to export.')
      }
  } else {
      $shell.Utilities.openInfoDialog('Error', 'There are no records to export!')
  }
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_row_selected');
  //O.Arias - 06/20/2024
  
  const selectedRowsCount = $grid.selectedRows.length;
  
  $grid.topToolbar.resubmit_message.control.readOnly = (selectedRowsCount > 0 ? false : true);
  $grid.topToolbar.delete_message.control.readOnly = (selectedRowsCount > 0 ? false : true);
  }
  on_resubmit_clicked(event = null) {
    return this.on_resubmit_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_resubmit_clickedInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_resubmit_clicked');
  //O.Arias - 06/22/2024
  
  const selected_rows = $grid.selectedRows;
  let errors: { reference: string, id: string, errorMessages: string[] }[] = [];
  let resubmitted_records = [];
  
  if (selected_rows.length === 0) {
      $shell.Utilities.openErrorDialog('Resubmit error!', 'No records were selected!');
      return;
  } else {
  
      const confirm_submit = (await $shell.Utilities.openConfirmationDialog(`Confirm resubmit!`, `Do you want to resubmit ${selected_rows.length} records?`, `Resubmit`, `Cancel`));
  
      if (confirm_submit) {
  
          for (const row of selected_rows) {
  
              let current_error: string;
              let success = false;
              current_error = null;
  
              try {
  
                  let entity = row.entity
  
                  if (entity.status_name === "Ready") {
                      throw ({ message: `Record ${entity.message_id} is already in Ready status.` })
                  }
  
                  let message: $types.Utilities.Message;
                  message = entity;
                  message.status_name = `Ready`;
                  message.process_name = `messages_grid`;
                  delete message["created_by"]
                  delete message["created_on"]
                  delete message["modified_by"]
                  delete message["modified_on"]
  
                  await $flows.Utilities.messages_write({
                      input: [message],
                      criteria: { application_name: entity.application_name }
                  });
  
                  let log: $types.Utilities.Log;
                  log = entity;
                  log.process_name = `messages_grid`;
                  log.notes = `Resubmitted record [${entity.message_id}]!`
                  delete log["created_by"]
                  delete log["created_on"]
                  delete log["alerted_on"]
  
                  await $flows.Utilities.logs_write({
                      input: [log],
                      criteria: { application_name: entity.application_name }
                  });
  
                  success = true;
  
              } catch (error) {
  
                  let target_error = error;
  
                  if (typeof target_error === "string") {
                      target_error = { message: target_error }
                  } else {
                      while ($utils.isDefined(target_error.error)) {
                          target_error = target_error.error;
                      }
                  }
  
                  if (!$utils.isDefined(target_error.message)) {
                      target_error = { message: `Uncaught exception! ${JSON.stringify(target_error)}` }
                  }
  
                  current_error = target_error.message;
              }
  
              if (success) {
                  resubmitted_records.push(row.entity.message_id.toString())
              } else {
                  errors.push({
                      reference: row.entity.reference, id: row.entity.message_id, errorMessages: [current_error]
                  });
              }
          }
  
          if ($utils.isDefined(errors)) {
  
              await $shell.Utilities.openErrorDialog(
                  `Resubmitt record${selected_rows.length > 1 ? 's' : ''}`,
                  resubmitted_records.length > 0 ? `Record${selected_rows.length > 1 ? 's' : ''} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: resubmitted_records })).formattedValue} successfully resubmitted.` : `No records were resubmitted.`,
                  null,
                  `Errors resubmitting record${selected_rows.length > 1 ? 's' : ''}`,
                  errors.map(error => ({ detail: error.errorMessages[0], message: `Id: ${error.id} Reference: ${error.reference}` })))
          }
      }
  }
  
  $grid.refresh();
  }
  on_clean_clicked(event = null) {
    return this.on_clean_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_clean_clickedInternal(
    $grid: Utilities_messages_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.logger.log('Utilities', 'messages_grid.on_clean_clicked');
  //O.Arias - 06/24/2024
  
  let get_date = (await $flows.Utilities.messages_clean({ criteria: { application_name: $grid.inParams.application_name, confirm: false } }))
  
  if ($utils.isDefined(get_date?.date_to)) {
  
      let date_to = new Date(get_date?.date_to);
  
      const confirm_purge = (await $shell.Utilities.openConfirmationDialog(`Confirm clean!`, `This will attempt to purge aproximately ${get_date.count} records as of ${date_to.toLocaleDateString()}.`, `Proceed`, `Cancel`));
  
      if (confirm_purge) {
  
          await $flows.Utilities.messages_clean({ criteria: { application_name: $grid.inParams.application_name, date_to: get_date?.date_to, confirm: true } });
      }
  
  } else {
  
      let totalCount: number = $grid.totalCount ?? 0;
  
      if (totalCount <= 1000) {
          $shell.Utilities.openErrorDialog("Error!", `A clean-up is not required, as there are less than 5,000 records (${totalCount.toLocaleString()}).`)
      } else {
          $shell.Utilities.openErrorDialog("Error!", "Could not determine a date to start the clean-up!")
      }
  }
  
  $grid.refresh()
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'Utilities_messages_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
